
import { showAuthPopup } from 'shared/auth';
import { AuthService, UserClaims } from 'shared/mechanics/auth';

export const checkUserClaims = (userClaim: UserClaims, functionalName: string, action: () => void) => {
	const userAuthorization = AuthService.resolveUserAuthorization();
	const haveClaim = userAuthorization.haveClaim(userClaim);
	if (haveClaim) {
		return action();
	}
	else {
		showAuthPopup({ title: functionalName });
	}
}